/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantAssets
 */
export interface TenantAssets {
    /**
     * 
     * @type {string}
     * @memberof TenantAssets
     */
    logo_color?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAssets
     */
    logo_white?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAssets
     */
    logo_full_color?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAssets
     */
    logo_full_white?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAssets
     */
    icon_color?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAssets
     */
    icon_white?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAssets
     */
    favicon?: string;
}

/**
 * Check if a given object implements the TenantAssets interface.
 */
export function instanceOfTenantAssets(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantAssetsFromJSON(json: any): TenantAssets {
    return TenantAssetsFromJSONTyped(json, false);
}

export function TenantAssetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantAssets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logo_color': !exists(json, 'logo_color') ? undefined : json['logo_color'],
        'logo_white': !exists(json, 'logo_white') ? undefined : json['logo_white'],
        'logo_full_color': !exists(json, 'logo_full_color') ? undefined : json['logo_full_color'],
        'logo_full_white': !exists(json, 'logo_full_white') ? undefined : json['logo_full_white'],
        'icon_color': !exists(json, 'icon_color') ? undefined : json['icon_color'],
        'icon_white': !exists(json, 'icon_white') ? undefined : json['icon_white'],
        'favicon': !exists(json, 'favicon') ? undefined : json['favicon'],
    };
}

export function TenantAssetsToJSON(value?: TenantAssets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'logo_color': value.logo_color,
        'logo_white': value.logo_white,
        'logo_full_color': value.logo_full_color,
        'logo_full_white': value.logo_full_white,
        'icon_color': value.icon_color,
        'icon_white': value.icon_white,
        'favicon': value.favicon,
    };
}

